// Magnifier lens for the single-product gallery.
//
// WooCommerce's stock zoom (disabled via `add_theme_support` in
// inc/setup.php) doesn't play nice with this theme's grid, so we ship our
// own classic shop magnifier in vanilla JS: a circular lens that follows
// the cursor over the main image and shows a magnified view of the spot.

const LENS_SIZE = 320; // px, mirrors .product-zoom-lens in _shop.scss
const ZOOM = 2.5;

export function initProductZoom() {
  // Touch screens have no hover — the lightbox covers zoom there.
  if (window.matchMedia('(hover: none)').matches) return;

  const gallery = document.querySelector('.woocommerce-single .woocommerce-product-gallery');
  if (!gallery) return;

  const mainImage = gallery.querySelector('.flex-viewport img, .woocommerce-product-gallery__image img');
  if (!mainImage) return;

  const lens = document.createElement('div');
  lens.className = 'product-zoom-lens';
  gallery.appendChild(lens);

  // Percentage-based background positioning scales to any image size, so we
  // only need to flip background-size when the active image changes size.
  let currentSrc = null;

  function activeImage() {
    const slide = gallery.querySelector('.flex-active-slide img');
    return slide || mainImage;
  }

  function positionLens(x, y) {
    lens.style.left = `${x}px`;
    lens.style.top = `${y}px`;
  }

  function updateZoom(clientX, clientY) {
    const bounds = gallery.getBoundingClientRect();

    const posX = clientX - bounds.left;
    const posY = clientY - bounds.top;

    // Constrain the lens center to the gallery box.
    const px = Math.min(1, Math.max(0, posX / bounds.width));
    const py = Math.min(1, Math.max(0, posY / bounds.height));

    positionLens(px * bounds.width, py * bounds.height);

    const img = activeImage();

    // Variation swatches/Gallery slides can swap the image on the fly.
    const src = img.currentSrc || img.src;
    if (src !== currentSrc) {
      currentSrc = src;
      lens.style.backgroundImage = `url("${src}")`;
      // Render the natural pixel size scaled by ZOOM, so background-position
      // percentages pan across the magnified image exactly under the cursor.
      lens.style.backgroundSize = `${img.naturalWidth * ZOOM}px ${img.naturalHeight * ZOOM}px`;
    }

    lens.style.backgroundPosition = `${px * 100}% ${py * 100}%`;
  }

  const onMove = (e) => updateZoom(e.clientX, e.clientY);

  if (mainImage.complete) {
    gallery.addEventListener('mousemove', onMove);
    gallery.addEventListener('mouseenter', () => lens.classList.add('is-active'));
    gallery.addEventListener('mouseleave', () => lens.classList.remove('is-active'));
  } else {
    mainImage.addEventListener('load', () => {
      gallery.addEventListener('mousemove', onMove);
      gallery.addEventListener('mouseenter', () => lens.classList.add('is-active'));
      gallery.addEventListener('mouseleave', () => lens.classList.remove('is-active'));
    });
  }
}